import Swiper from 'swiper';
// Bikes
new Swiper('.search-results__carousel--bike', {
  direction: 'horizontal',
  loop: false,
  slidesPerView: 1,
  grid: {
    rows: 3,
  },
  spaceBetween: 1,

  pagination: {
    el: '.search-results__carousel-navigation--bike .swiper-pagination',
    type: 'fraction',
  },

  navigation: {
    nextEl: '.search-results__carousel-navigation--bike .swiper-button-next',
    prevEl: '.search-results__carousel-navigation--bike .swiper-button-prev',
  },
});
// Posts
new Swiper('.search-results__carousel--post', {
  direction: 'horizontal',
  loop: false,
  slidesPerView: 1,
  grid: {
    rows: 3,
  },
  spaceBetween: 1,

  pagination: {
    el: '.search-results__carousel-navigation--post .swiper-pagination',
    type: 'fraction',
  },

  navigation: {
    nextEl: '.search-results__carousel-navigation--post .swiper-button-next',
    prevEl: '.search-results__carousel-navigation--post .swiper-button-prev',
  },
});
// pages
new Swiper('.search-results__carousel--page', {
  direction: 'horizontal',
  loop: false,
  slidesPerView: 1,
  grid: {
    rows: 3,
  },
  spaceBetween: 1,

  pagination: {
    el: '.search-results__carousel-navigation--page .swiper-pagination',
    type: 'fraction',
  },

  navigation: {
    nextEl: '.search-results__carousel-navigation--page .swiper-button-next',
    prevEl: '.search-results__carousel-navigation--page .swiper-button-prev',
  },
});

// faqs
new Swiper('.search-results__carousel--faq', {
  direction: 'horizontal',
  loop: false,
  slidesPerView: 1,
  grid: {
    rows: 4,
  },
  spaceBetween: 0,

  pagination: {
    el: '.search-results__carousel-navigation--faq .swiper-pagination',
    type: 'fraction',
  },

  navigation: {
    nextEl: '.search-results__carousel-navigation--faq .swiper-button-next',
    prevEl: '.search-results__carousel-navigation--faq .swiper-button-prev',
  },
});

// Careers
new Swiper('.search-results__carousel--career', {
  direction: 'horizontal',
  loop: false,
  slidesPerView: 1,
  grid: {
    rows: 4,
  },
  spaceBetween: 0,

  pagination: {
    el: '.search-results__carousel-navigation--career .swiper-pagination',
    type: 'fraction',
  },

  navigation: {
    nextEl: '.search-results__carousel-navigation--career .swiper-button-next',
    prevEl: '.search-results__carousel-navigation--career .swiper-button-prev',
  },
});
